import { MARKETS_UPDATE } from '../../general/sockets/actionTypes'
import {
  MARKETS_FETCH,
  MARKETS_FETCH_SUCCESSFUL,
  MARKETS_FETCH_FAILED,
  UPDATE_FAVORITE,
  UPDATE_FAVORITE_FAIL,
  UPDATE_FAVORITE_SUCCESS,
  PRICING_FETCH,
  PRICING_FETCH_SUCCESSFUL,
  PRICING_FETCH_FAILED,
  MARKETS_FETCH_SPECIFIC_SUCCESSFUL
} from './actionTypes'

const initialState = {
  loading: false,
  error: '',
  markets: [],
  marketNames: [],
  pricingData: [],
  pricingLoading: false,
  pricingError: '',
  clearingCounter: 0,
  editClearingCounter: 0,
  deleteClearingCounter: 0,
  selectedMarket: {},
}

const updateMarkets = (currentMarkets, newData) => {
  let updatedData = currentMarkets
  updatedData = updatedData.map((market) => {
    const found = newData.find((x) => x.pairName === market.pairName)
    return {
      ...market,
      ...found,
    }
  })
  return updatedData
}

const getMarketNames = (markets) => {
  return markets ? markets.map((m) => m.pairName) : []
}

const mergePricingWithMarkets = (markets, pricingData) => {
  if (!markets || !pricingData) return markets

  return markets.map((market) => {
    const pricingMatch = pricingData.find((pricing) => 
      pricing.pairName === market.pairName || 
      pricing.symbol.toLowerCase() === market.pairName?.replace('/', '').toLowerCase()
    )

    if (pricingMatch) {
      return {
        ...market,
        htxPricing: {
          currentPrice: pricingMatch.currentPrice,
          percentage: pricingMatch.percentage,
          isPositive: pricingMatch.isPositive,
          high24h: pricingMatch.high,
          low24h: pricingMatch.low,
          volume24h: pricingMatch.volume,
          open: pricingMatch.open,
          buyPrice: pricingMatch.buyPrice,
          sellPrice: pricingMatch.sellPrice,
          lastUpdated: pricingMatch.lastUpdated,
        }
      }
    }

    return market
  })
}

const marketsReducer = (state = initialState, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case MARKETS_FETCH:
      state = {
        ...state,
        loading: true,
      }
      break
    case MARKETS_UPDATE:
      // eslint-disable-next-line no-case-declarations
      const markets = updateMarkets(state.markets, action.payload)
      state = {
        ...state,
        markets,
      }
      break
    case MARKETS_FETCH_SUCCESSFUL:
      const marketNames = getMarketNames(action.payload)

      state = {
        ...state,
        loading: false,
        markets: action.payload,
        marketNames,
      }
      break
    case MARKETS_FETCH_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload.error,
      }
      break
    case UPDATE_FAVORITE:
      state = {
        ...state,
        updating: true,
      }
      break
    case UPDATE_FAVORITE_SUCCESS:
      state = {
        ...state,
        updating: false,
        error: null,
      }
      break
    case PRICING_FETCH:
      state = {
        ...state,
        pricingLoading: true,
        pricingError: '',
      }
      break
    case PRICING_FETCH_SUCCESSFUL:
      state = {
        ...state,
        pricingLoading: false,
        pricingData: action.payload,
        pricingError: '',
      }
      break
    case PRICING_FETCH_FAILED:
      state = {
        ...state,
        pricingLoading: false,
        pricingError: action.payload,
      }
      break
    case MARKETS_FETCH_SPECIFIC_SUCCESSFUL:
      state = {
        ...state,
        selectedMarket: action.payload,
        error: null,
      }
      break
    default:
      state = { ...state }
  }
  return state
}

export default marketsReducer
